import * as React from 'react';
import {Form, Input, Button} from 'antd';
import ReactQuill, { Quill } from 'react-quill';
import "react-quill/dist/quill.snow.css";
import {useTranslation} from "react-i18next";
import {useHistory} from "react-router-dom";

interface Props {
    fields: any[];
    onChange: (fields: any[]) => void;
    onLogin: (login: string, password: string) => void;
    loading: boolean;
}

export default function LoginForm({
                                      fields,
                                      onChange,
                                      onLogin,
                                      loading,
                                  }: Props) {
    const {t} = useTranslation();
    const history = useHistory();
    const [form] = Form.useForm();


    function handleSubmit(values: any) {
        if (onLogin) {
            const {email, password} = values;
            onLogin(email, password);
        }
    }

    return (
        <Form
            size="large"
            form={form}
            fields={fields}
            onFieldsChange={(changedFields, allFields) => {
                onChange(allFields);
            }}
            onFinish={handleSubmit}
            layout="vertical"
            requiredMark={false}
        >
            <Form.Item
                label={t("login.email.label")}
                name="email"
                rules={[
                    {required: true, message: t('login.email.required')},
                ]}
            >
                <Input className='br-5px'/>
            </Form.Item>
            <div className="__password">
                <Form.Item
                    label={t("login.password.label")}
                    name="password"
                    rules={[
                        {required: true, message: t('login.password.required')},
                    ]}
                >
                    <Input.Password
                        type="password"
                        className='br-5px'
                    />
                </Form.Item>
                <div className="">
					<div className="row">
						<div className="col-12 col-sm-6 mt-2">
							<div className="form-check">
							  <label className="form-check-label text-secondary">
							    <input type="checkbox" className="form-check-input" value=""/>&nbsp;&nbsp;{t('genDict.RememberMe')}
							  </label>
							</div>
						</div>
						<div className="col-12 col-sm-6 text-sm-right mt-2">
							<a href="/reset-password" className="text-4f46e5">{t('genDict.ForgotPassword')}</a>
						</div>
					</div>
				</div>
            </div>
            <Form.Item>
                <Button
                    htmlType="submit"
                    loading={loading}
                    shape="round"
                    size={"large"}
                    className="btn btn-blue submit w-100"
                >
                    {t('login.connect')}
                </Button>
            </Form.Item>
        </Form>
    );
}
